module.exports = __webpack_public_path__ + "img/ask-doctor.00dc62fc.png";